module.exports = __webpack_public_path__ + "static/img/unionPay.4d7b161.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/footer/unionPay.png
// module id = DtUW
// module chunks = 3